import { Stack, Typography, styled, type CSSObject } from '@mui/material';
import { Section } from '@rumblefish/ui/Rumblefish23Theme';

export const AiKnowledgeManagementSolutionsLatestFaqSection = styled(Section)(
  () => ({
    contain: 'paint',
    overflow: 'hidden',
  })
);
export const AiKnowledgeManagementSolutionsFaqStyledStack = styled(Stack)(
  ({ theme }) => ({
    padding: theme.spacing(11, 0, 0, 0),
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(8, 0),
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(6, 0),
    },
  })
);

export const AiKnowledgeManagementSolutionsFaqStyledContentStack = styled(
  Stack
)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(10),

  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    gap: theme.spacing(5),
  },
}));
export const AiKnowledgeManagementSolutionsFaqGlowStack = styled(Stack)(() => ({
  width: '70%',
  height: 'calc(70vw / 2)',
  borderRadius: '0 0 calc(70vw / 2) calc(70vw / 2)',
  position: 'absolute',
  transform: 'translateX(-50%) translateY(0%) translateZ(0)',
  zIndex: -1,
  left: '50%',
  background: 'rgba(255,255,255,0.05)',
  willChange: 'transform',
  filter: 'blur(200px)',
}));
export const AiKnowledgeManagementSolutionsFaqStyledTextStack = styled(Stack)(
  ({ theme }) => ({
    flex: 0.85,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    [theme.breakpoints.down('xl')]: {
      flex: 0.95,
    },
    [theme.breakpoints.down('lg')]: {
      flex: 1,
    },
  })
);

export const AiKnowledgeManagementSolutionsFaqStyledAccordionStack = styled(
  Stack
)(({ theme }) => ({
  flex: 1,
  paddingBottom: theme.spacing(11),
  [theme.breakpoints.down('md')]: {
    paddingBottom: theme.spacing(0),
  },
}));

export const AiKnowledgeManagementSolutionsFaqMainText = styled(Typography)(
  ({ theme }) => ({
    ...(theme.mixins.neutralGradient as CSSObject),
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  })
);

export const AiKnowledgeManagementSolutionsFaqDescriptionText = styled(
  Typography
)(({ theme }) => ({
  color: theme.palette.invertedContent?.PRIMARY,
}));
